<template>
  <div>
    <HeroBanner />
    <IntroNotices />
    <HomePortalSection />
    <FooterNavStrip />
  </div>
</template>

<script>
import HeroBanner from '../../components/home/HeroBanner.vue'
import IntroNotices from '../../components/home/IntroNotices.vue'
import HomePortalSection from '../../components/home/HomePortalSection.vue'
import FooterNavStrip from '../../components/home/FooterNavStrip.vue'

export default {
  name: 'HomePage',
  components: {
    HeroBanner,
    IntroNotices,
    HomePortalSection,
    FooterNavStrip
  }
}
</script>
